import { Paper, Text, Group, createStyles, Box, Stack } from '@mantine/core';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useDasboardApi from '../../hooks/useDashboardApi';
import DetailMenu from './card-components/DetailMenu';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';

// Custom styles
const useStyles = createStyles((theme) => ({
	container: {
		padding: '20px 0 10px'
	},
	text: {
		fontSize: 32,
		lineHeight: '38px',
		fontWeight: 400,
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	},
	cardTitle: {
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '20px',
		color: theme.colorScheme === 'light' ? '#4A4A4A' : '#C1C2C5',
	},
	levelText: {
		color: theme.colorScheme === 'dark' ? theme.colors.mainPurple[0] : theme.colors.mainPurple[2],
		fontSize: 12,
		lineHeight: '16px',
		fontWeight: 700
	}
}));

export default function TotalBenefits() {

	// State and hooks
	const { classes } = useStyles();
	const { getBenefitsPerLevel } = useDasboardApi();
	const totalBenefitsPerLevel = useSelector(state => state.dashboardData.totalBenefitsPerLevel);

	// On load
	useEffect(() => {
		async function fetchData() {
			await getBenefitsPerLevel('', '');
		}
		fetchData();
		// eslint-disable-next-line
	}, []);

	// Render each benefit
	const eachBenefit = (val, i) => {

		// Return
		return (
			<Stack
				key={i}
				spacing={0}
				align="center"
			>
				{/* Count */}
				<Text className={classes.text}>
					{val.count}
				</Text>
				{/* Level */}
				<Text className={classes.levelText}>
					{val.name}
				</Text>
			</Stack>
		);

	}

	// Convert and download as CSV file
	const convertToCSV = () => {

		// Convert to object
		const jsonData = totalBenefitsPerLevel.map((val) => ({
			[val.name]: val.count
		}));

		// Copy and stringify
		const parsedData = jsonData.reduce((acc, item) => {
			const key = Object.keys(item)[0];
			const value = Object.values(item)[0];
			acc[key] = value;
			return acc;
		}, {});

		// Parse and convert to CSV
		const csv = Papa.unparse([parsedData], { header: true });

		// Generate file
		const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

		// Save file
		saveAs(blob, 'beneficios.csv');

	};

	return (
		<Paper
			withBorder
			p={12}
			style={{ minHeight: 152 }}
			radius={18}
		>
			{/* Top */}
			<Group
				position="apart"
				noWrap
			>
				{/* Title */}
				<Text className={classes.cardTitle}>
					Beneficios
				</Text>
				{/* Menu */}
				<DetailMenu onClick={() => convertToCSV()} />
			</Group>
			{/* Content */}
			<Box className={classes.container}>
				<Group
					position="center"
					align="center"
					mt={14}
					spacing={40}
				>
					{totalBenefitsPerLevel ? totalBenefitsPerLevel.map(eachBenefit) : ''}
				</Group>
			</Box>
		</Paper>
	);

}
